export type ResultSet = {
  index: string
  title: string
  hitsPerPage: number
}

/**********************************
 *  CONFIG
 **********************************/
const resultSets: ResultSet[] = [
  {
    index: 'courses',
    title: 'Courses',
    hitsPerPage: 2,
  },
  {
    index: 'conferences',
    title: 'Conferences',
    hitsPerPage: 2,
  },
  {
    index: 'performance_resources',
    title: 'Performance Resources',
    hitsPerPage: 3,
  },
  {
    index: 'webinars',
    title: 'Webinars',
    hitsPerPage: 3,
  },
  {
    index: 'publications',
    title: 'Publications',
    hitsPerPage: 2,
  },
  {
    index: 'articles',
    title: 'Articles',
    hitsPerPage: 3,
  },
  {
    index: 'videos',
    title: 'Videos',
    hitsPerPage: 3,
  },
  {
    index: 'podcasts',
    title: 'Podcasts',
    hitsPerPage: 3,
  },
  {
    index: 'blogs',
    title: 'Blogs',
    hitsPerPage: 2,
  },
  {
    index: 'pages',
    title: 'Pages',
    hitsPerPage: 1,
  },
  {
    index: 'certification',
    title: 'Certification',
    hitsPerPage: 2,
  },
  {
    index: 'users',
    title: 'People',
    hitsPerPage: 3,
  },
]

export default resultSets
